import { gql } from '@apollo/client'

const DISHES_PROGRESS_COUNTS_QUERY = gql`
  query dishesProgressCountsQuery($menuId: ID!) {
    dishesProgressCounts(menuId: $menuId) {
      availableForWorkCount
      doneCount
    }
  }
`

export default DISHES_PROGRESS_COUNTS_QUERY
